import { useState } from 'react';
import { useFormik } from 'formik';
import { Box, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { pushDL } from '@lendica/api';
import * as api from '../api';
import { PhoneFormat } from '../utils/components';
import { MessageCard } from './MessageCard';
import { Heading } from './Typography';
import { useAppContainerContext } from './AppContainer';

export const Phone = ({ onNavForward, setPhone, heading, body }: any) => {
    const [loading, setLoading] = useState(false);
    const { setError } = useAppContainerContext();

    const formik = useFormik({
        initialValues: {
            phone: '',
        },
        validationSchema: api.phoneSchema,
        onSubmit: async ({ phone }) => {
            try {
                setLoading(true);
                await api.phone(phone);

                // Track phone auth step
                pushDL('auth_step', {
                    step: 'phone_submit',
                    phone: phone,
                });

                setPhone(phone);
                onNavForward();
                setLoading(false);
            } catch (error: any) {
                setError(error?.message || 'Something went wrong.');
                // Track phone auth error
                pushDL('auth_step', {
                    step: 'phone_submit_error',
                    error: error?.message || 'phone_submit_failed',
                });

                setTimeout(() => {
                    setError(null);
                }, 2500);
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <Box
            component="form"
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
            }}
            onSubmit={formik.handleSubmit}
        >
            <Heading>{heading ? heading : 'Welcome to Lendica!'}</Heading>
            <MessageCard>{body ? body : 'Get ready to be funded in two minutes 🚀.'}</MessageCard>
            <TextField
                label="Phone number"
                name="phone"
                fullWidth
                margin="normal"
                InputProps={{ inputComponent: PhoneFormat }}
                inputProps={{ 'data-testid': 'phone' }}
                value={formik.values.phone}
                onChange={formik.handleChange}
                error={!!(formik.touched.phone && formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone ? formik.errors.phone : ' '}
            />

            <Box display="flex" flexDirection="column" justifyContent="center" mt={1}>
                <Typography variant="caption" align="center" mb={1} mt={1.5}>
                    We'll send you a one-time code to verify.
                </Typography>
            </Box>

            <LoadingButton
                type="submit"
                size="large"
                color="primary"
                variant="contained"
                fullWidth
                sx={{ marginTop: 2 }}
                data-testid="submit"
                loading={loading}
            >
                Send code
            </LoadingButton>
        </Box>
    );
};

export default Phone;
